import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { authTokenCookie } from '../utils/CookieMaker';
import { getAPIMKey } from '../component/Screens/employeeDiscount/employeeDiscountForm/employeeDiscountFormAction';
import { logout } from '../utils/utils';

import { LOGIN_ROOT } from '../service/apiUrls';
//import { userRoleVal } from 'utils/constants';

export const AccessDetailsProvider = ({ children }) => {
    const { authCookie } = authTokenCookie();
    // const { fetchAccessDetails, accessDetailsError,accessDetailsLoading, accessDetailsData } = useAccessDetails();
    // const { fetchFieldDetails, fieldDetailsError, fieldDetailsLoading, fieldDetailsData } = useFieldDetails();
    const { userInfo } = authTokenCookie();
    const [authenticated, setAuthenticated] = useState(false);
    const [alertTimer, setAlertTimer] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        //  if ((authCookie.name !== null && !authenticated) || userType ===`external` ) {  //sessionid check removed for validating ediection issue
        if (authCookie.name !== null && !authenticated) {
            dispatch(getAPIMKey());
            setAuthenticated(true);
            sessionStorage.setItem("sessionId", userInfo.userId)
        }
        else {
            document.cookie.split(";").map(cookies => {
                document.cookie = cookies.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
                return cookies;
            });
            sessionStorage.clear();
            sessionStorage.setItem("sessionId", userInfo.userId);
            window.location.replace(`${LOGIN_ROOT}/authenticate`);
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const timer = setInterval(() => {
            let currentDate = new Date();
            let currentTime = currentDate.getTime();
            let { decodedIdToken, userInfo, authCookie } = authTokenCookie();
            // JWT exp is in seconds
            let sessionId = sessionStorage.getItem('sessionId')
            if (authCookie && authCookie.name && sessionId === userInfo.userId) {
                let tokenExpiry = decodedIdToken.exp * 1000;
                console.log(`Timer check`, tokenExpiry, currentTime);
                if (currentTime + 300000 >= tokenExpiry && !alertTimer) {
                    //  alert(`your session about to expire, please refresh the browser to retain the session`)
                    setAlertTimer(true);
                }
                else if (tokenExpiry <= currentTime) {
                    //  window.location.replace(`${LOGIN_ROOT}/refresh`);
                    logout();
                }
            }
            else if (authenticated && authCookie.name === null) {
                logout();
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [authenticated, alertTimer]);


    if (authenticated) {
        return <>{children}</>
    }
    else {
        return null;
    }
};

export default AccessDetailsProvider;